import React from "react";
import {
    PaymentRequestButtonElement 
} from "@stripe/react-stripe-js";
import { CSSTransition } from "react-transition-group";
import PropTypes from "prop-types";

const BrowserCardPaymentForm = ({
    paymentSucceeded,
    paymentRequest    
   }) => {

    return (
        <CSSTransition
            in={!paymentSucceeded}
            timeout={1000}
            classNames="fade"
            unmountOnExit
        >
            <>
                <div id="BrowserPaymentWrapper">
                    <PaymentRequestButtonElement options={{ paymentRequest }} />
                </div>
                <p>Or pay by card</p>
            </>
        </CSSTransition>
    );
}

BrowserCardPaymentForm.propTypes = {
    paymentSucceeded: PropTypes.bool.isRequired,
    paymentRequest: PropTypes.object.isRequired
}

export default BrowserCardPaymentForm;